import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import { useAppSelector } from '../../hooks/useReduxHook';
import { UserRoleName } from '../../services/identity/types/UserProfile';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import CCAppointments from './CareAdvisor/Appointments';
import PatientAppointments from './Patient/Appointments';
import ProviderAppointments from './Provider/Appointments';

const Appointments: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.CareAdvisor:
      component = <CCAppointments />;
      break;
    case UserRoleName.Provider:
      component = <ProviderAppointments />;
      break;
    case UserRoleName.Patient:
      component = <PatientAppointments />;
      break;
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default Appointments;
